module.exports = Em.View.extend({
    templateName: 'organization/background-tasks',

    classNameBindings: [':background-tasks']
})
